import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home, SearchResult, ErrorPage, Checkout } from "./routes";
import TestApi from "./routes/testapi";
import Resume from "./routes/resume/Resume";
import Confirmation from "./routes/confirmation/Confirmation";
import TimeOut from "./routes/timeout/TimeOut";
import FareOptions from "./routes/flight/FareOptions";
import { AuthUserProvider } from "./context/auth.context";
import UserProfile from "./routes/userprofile/UserProfile";

const App = () => {
  return (
    <BrowserRouter>
      <AuthUserProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/flights" element={<SearchResult />} />
          <Route path="/flights/:index" element={<SearchResult />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/test" element={<TestApi />} />
          <Route path="/orderresume" element={<Resume />} />
          <Route path="/payment_confirmation" element={<Confirmation />} />
          <Route path="/fares" element={<FareOptions />} />
          <Route path="/profile" element={<UserProfile />} />

          <Route path="/timeout" element={<TimeOut />} />

          <Route path="**" element={<ErrorPage />} />
        </Routes>
      </AuthUserProvider>
    </BrowserRouter>
  );
};

export default App;
